import { merge } from 'd3-array';
import { scaleLinear } from 'd3-scale';

import { idKey, timeSort } from '../utils/dataUtils';
import { getHourBasedTimeScale } from '../utils/svgUtils';
import './Dashboard.css';

function bolusAccessor(d) {
  return d.amount;
}

function render(selection) {
  const {
    data,
    focus,
    width = 720,
    height = 170,
    t,
  } = selection.datum();

  const boluses = merge(Object.values(data || {}));
  console.log('Bolus', { boluses, data });

  const bolusData = merge(Object.values(data || {}))
    .sort(timeSort);

  const timeScale = getHourBasedTimeScale({ width });

  const maxBolus = 20;

  const y = scaleLinear().domain([0, maxBolus]).range([height, 0]);

  const graphsG = selection
    .selectAll('g.graphs')
    .data([1])
    .join('g')
      .attr('class', `${focus ? `${focus} ` : ''}bolus scatterplot graphs`)
      .classed('bolus scatterplot', true);

    /*
    .join(
      enter => enter.append('g')
        .attr('class', 'bolus scatterplot graphs'),
      update => update
        .classed('bolus scatterplot', true),
      exit => exit.remove(),
    );
    */

  graphsG.selectAll('.bolus')
    .data(bolusData, idKey)
    .join('circle')
      .attr('class', d => `${bolusAccessor(d) < 0.5 ? 'micro ' : ''}${d.mealBolus ? 'meal' : 'correction'} bolus entry`)
      .attr('title', bolusAccessor)
      .attr('cx', timeScale)
      .attr('cy', d => y(bolusAccessor(d)))
      .attr('r', d => (bolusAccessor(d) < 0.5 ? 5 : 8));

  graphsG.selectAll('circle.bolus.indicator')
    .data(bolusData.filter(d => d.mealBolus), idKey)
    .join('circle', )
      .attr('class', d => `${bolusAccessor(d) < 0.5 ? 'micro ' : ''}${d.mealBolus ? 'meal' : 'correction'} bolus indicator`)
      .attr('title', bolusAccessor)
      .attr('cx', timeScale)
      .attr('cy', d => y(bolusAccessor(d)))
      .attr('r', 3);
  
}

const BolusScatterPlot = {
  init: f => f,
  render,
  destroy: f => f,
};

export default BolusScatterPlot;
